import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import NewSessionOnReferrerChange from './NewSessionOnReferrerChange';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedNewSessionOnReferrerChange = connect(
  mapStateToProps, null,
)(NewSessionOnReferrerChange);

export default withTranslation(['administration'])(ConnectedNewSessionOnReferrerChange as any);
